import { render, staticRenderFns } from "./AddContentInHub.vue?vue&type=template&id=6955c93a"
import script from "./AddContentInHub.vue?vue&type=script&lang=js"
export * from "./AddContentInHub.vue?vue&type=script&lang=js"
import style0 from "./AddContentInHub.vue?vue&type=style&index=0&id=6955c93a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports